module.exports = __webpack_public_path__ + "img/527d601d0fb504a326d5fd5c023e234f.png";